<template>
  <div
    v-if="!!ownsStory"
    class="StoryAdminBar w-full bg-white"
  >
    <div class="mx-auto max-w-screen-xl px-4">
      <div class="flex justify-end py-4">
        <a
          :href="editUrl"
          class="px-4 font-display text-sm font-semibold uppercase text-ink hover:text-accent"
          data-testid="StoryEditLink"
          target="hf_story_edit"
        >
          {{ $t('forms.edit') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * @module StoryAdminBar
 */
export default {
  name: 'StoryAdminBar',

  props: {
    /**
     * The currently opened story
     */
    story: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('personalNewsrooms', ['newsroomsFlat']),

    /**
     * Returns the story's newsroom from the Users newsrooms
     * @returns {object} - Newsroom
     */
    storyNewsroom () {
      return this.newsroomsFlat.find(newsroom => newsroom.slug === this.story.newsroom_slug)
    },

    /**
     * Checks if the user is the owner of the current viewed story
     * @returns {boolean}
     */
    ownsStory () {
      return !!this.storyNewsroom
    },

    editUrl () {
      if (!this.ownsStory) return

      return this.$getUrl(`stories/story/${this.story.id}/edit?brand=${this.storyNewsroom.brandId}`, 'hypefactors', false)
    }
  }
}
</script>
